import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=c5c0971e"
import script from "./Cities.vue?vue&type=script&lang=js"
export * from "./Cities.vue?vue&type=script&lang=js"
import style0 from "./Cities.vue?vue&type=style&index=0&id=c5c0971e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports